import { render } from "./HolidayIcon.vue?vue&type=template&id=1bb3e38c"
import script from "./HolidayIcon.vue?vue&type=script&lang=js"
export * from "./HolidayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__